<template>
  <section class="content">
    <div class="row center-block">
      <!--<h2>Data tables</h2>-->
      <div class="col-md-12">
        <div class="box text-center">
          <!-- /.box-header -->
          <div class="box-body form">
            <br>
            <div>
              <div class="input-group">
                <span class="input-group-addon">
                  <span class="text-red">＊ </span>品牌
                </span>
                <div class="form-group">
                  <select class="form-control" v-model="brandSelect">
                    <option :value="brand.value" v-for="brand in brandBrief">{{brand.label}}</option>
                  </select>
                </div>
              </div>
              <br />
            </div>
            <div>
              <div class="input-group">
                <span class="input-group-addon">
                  <span class="text-red">＊ </span>店家
                </span>
                <div class="form-group">
                  <select class="form-control" v-model="storeSelect">
                    <option :value="store.value" v-for="store in storeBrief">{{store.label}}</option>
                  </select>
                </div>
              </div>
              <br />
            </div>
            <div>
              <div class="input-group">
                <span class="input-group-addon">
                  <span class="text-red">＊ </span>交易序號
                </span>
                <input class="form-control" placeholder="" type="text" v-model="info.trade_no" maxlength="45">
              </div>
              <br />
            </div>
            <div>
              <div class="input-group">
                <span class="input-group-addon">
                  <span class="text-red">＊ </span>線上付款類型
                </span>
                <div class="form-group">
                  <select class="form-control h-38" v-model="tradeTypeSelect">
                    <option v-for="trade in getECtradeType" :value="trade.value">
                      {{trade.label}}
                    </option>
                  </select>
                </div>
              </div>
              <br />
            </div>
          </div>
          <div class="box-footer text-center">
            <button class="btn btn-success" @click="searchAccount()">
              查詢
            </button>
          </div>
          <br />
          <div class="box-body form text-left">
            <pre>{{JSON.stringify(tradeInfo, null, 2)}}</pre>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      brandSelect: 0,
      storeSelect: 0,
      tradeTypeSelect: 707,
      storeBrief: [],
      brandBrief: [],
      info: {
        trade_no: ''
      },
      tradeInfo: {}
    }
  },
  methods: {
    checkInput () {
      var msg = ''
      if (!this.storeSelect) {
        msg = '請選擇店家'
      } else if (!this.info.trade_no) {
        msg = '請輸入交易序號'
      }
      this.getToast(msg)
    },
    getToast (msg) {
      if (msg) {
        this.$notify({
          title: '提醒',
          text: msg,
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else {
        this.searchAccount()
      }
    },
    searchAccount () {
      var self = this
      var url = '/accounting/tradeInfo?store_id=' + this.storeSelect + '&trade_no=' + this.info.trade_no + '&trade_type=' + this.tradeTypeSelect
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.tradeInfo = response.data.trade_info
        }
      })
    },
    getBrandBrief () {
      var self = this
      var url = '/brand/listBrief?is_delete=0&is_opening=1&list_sort=name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list
          for (let i = 0; i < bList.length; i++) {
            let obj = {label: bList[i].name, value: bList[i].brand_id}
            self.brandBrief.push(obj)
            if (i === 0) self.brandSelect = obj.value
          }
        }
      })
    },
    getStoreBrief (brandId) {
      this.storeBrief = []
      var self = this
      var url = '/brand/' + brandId + '/storeListBrief?status=2&list_sort=name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list
          for (let i = 0; i < sList.length; i++) {
            let obj = {label: sList[i].name, value: sList[i].store_id}
            self.storeBrief.push(obj)
            if (i === 0) self.storeSelect = obj.value
          }
        }
      })
    }
  },
  computed: {
    ...mapGetters(['getECtradeType']),
    getDataH () {
      return this.$parent.getDataH
    }
  },
  created () {
    this.getBrandBrief()
  },
  watch: {
    brandSelect () {
      this.storeSelect = 0
      if (this.brandSelect !== 0 && this.brandSelect !== '0') {
        this.getStoreBrief(this.brandSelect)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// AccountSearch.vue?5cdc6014